"use strict";
/* globals module */
/**
 * @module articleSubscriptionsArticleModuleClient
 * @description  Article Subscriptions Article Module Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsClient` uses `articleSubscriptionsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ArticleSubscriptionsClient = /** @class */ (function () {
    function ArticleSubscriptionsClient(articleSubscriptionsRoute, apiClient) {
        this.articleSubscriptionsRoute = articleSubscriptionsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Subscribes user or existing user to article module updates. Returns a promise that is resolved once the subscribe action has been performed. This action subscribes an user to the article module.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleSubscriptionsArticleModuleClient.subscribe(data)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    ArticleSubscriptionsClient.prototype.subscribe = function (data) {
        return this.apiClient.post(this.articleSubscriptionsRoute.subscribe(data), data);
    };
    /**
     * Determines whether existing or anonymous user are subscribed to article module updates. Returns a promise that is resolved once the isSubscribed action has been performed. This action checks if a user is subscribed to the article module.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleSubscriptionsArticleModuleClient.isSubscribe(data)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
     **/
    ArticleSubscriptionsClient.prototype.isSubscribed = function (data) {
        return this.apiClient.get(this.routeDefinition.isSubscribed(data));
    };
    /**
     * Unsubscribe existing or anonymous user from article module updates. Returns a promise that is resolved once the unSubscribe action has been performed. This action unsubscribes a user from the article module.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the unSubscribe action has been performed.
     * @example articleSubscriptionsArticleModuleClient.unSubscribe(data)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });                          **/
    ArticleSubscriptionsClient.prototype.unSubscribe = function (data) {
        return this.apiClient.delete(this.routeDefinition.unSubscribe(data));
    };
    var _a, _b;
    ArticleSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleSubscriptionsRoute !== "undefined" && _1.ArticleSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSubscriptionsClient);
    return ArticleSubscriptionsClient;
}());
exports.ArticleSubscriptionsClient = ArticleSubscriptionsClient;
